import {httpV3Get} from "../network";

/**
 * Get group location id
 *
 * @param {String} key
 * @return {Promise}
 */
const getParentLocationId = key => {
  return httpV3Get(`/location/getGroupParentLocation?group=${key}`)
    .then(r => {
      if (200 !== r.status || "success" !== r.data.result) {
        return Promise.reject({response: r});
      }

      return r.data.data.location;
    });
};

/**
 * Get children locations info
 *
 * @param {String} parentLocationId
 * @return {Promise}
 */
const getChildrenLocations = parentLocationId => {
  return httpV3Get(`/location/getChildrenLocations?group=${parentLocationId}`)
    .then(r => {
      if (200 !== r.status || "success" !== r.data.result) {
        return Promise.reject({response: r});
      }

      return r.data.data;
    });
};

export {getParentLocationId, getChildrenLocations};
